Object.defineProperty(exports, '__esModule', {
  value: true
});

/**
 * Returns true if the string is whitespace only.
 * @param value The string to check.
 */
var isWhitespaceOnly = function isWhitespaceOnly(str) {
  return str.replace(/\s/g, "").length === 0;
};
exports.isWhitespaceOnly = isWhitespaceOnly;